
            const data = {"name":"glyph/24/triangle-down","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M21 5H3a1.001 1.001 0 0 0-.8 1.6l9 12a.998.998 0 0 0 1.6 0l9-12A.999.999 0 0 0 21 5z\" class=\"nc-icon-wrapper\" _fill=\"#3f3f3f\"/>","originalColors":[{"type":"fill","color":"#3f3f3f"}],"stopColors":[]}}
        
                    module.exports = data
                    